import { AllSystemProps, allSystemProps } from 'shared/styles/props';

import styled from '@emotion/styled';

export interface BoxProps extends AllSystemProps {
  className?: string;
  style?: React.CSSProperties;
}

export const Box = styled('div')<BoxProps>(
  {
    boxSizing: 'border-box',
  },
  allSystemProps
);
